import React, {useContext, useRef, useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import TextsContext from "../../TextsContent";
import Lottie from "react-lottie";
import ServerRequest from "../../ServerRequests/ServerRequest.js";
import animationData from "./avo-water.json";
import "./waterBalance.css";
import Routes from "../../assets/RoutesToPages/Routes";

const WaterBalance = () => {
  const navigate = useNavigate();
  const userID = localStorage.getItem("userHash") || null;
  let userData = JSON.parse(localStorage.getItem(userID)) || null;

  useEffect(() => {
    if (userID === null || userData === null) {
      navigate(Routes.welcomePage)
    }
  }, []);

  const texts = useContext(TextsContext);
  const animationWater = useRef(null);

  const [animationSpeed, setAnimationSpeed] = useState(1);
  const [isAnimating, setIsAnimating] = useState(false); // Створюємо стан для відслідковування анімації

  let userWeight = userData?.userProfileData.userWeight;
  let personCoeficient =
    userData?.userProfileData.userGender === "female" ? 30 : 35; //для жінок 30
  let neededWater = userWeight * personCoeficient; // in mililitres
  let step = 200;
  let stepsCount = Math.ceil(neededWater / step);
  let anSpeed = 1;

  //даний коефіцієнт був емпірично вирахуваний, і він означає співвідношення прописаних кадрів (frames) у анімації до фактично останнього помітного кадру, після якого анімація не змінюється. Саме тому і була похибка 1 кроку яка наростала зі збільшенням маси юзера до 2 і більше кроків.
  const badCualityLottieCoeficient = 450 / 380; //його можна було б прибрати якби останній прописаний кадр у анімаіцї був 450, і на 449-му було  б видко зміни. У нас зараз після 380-го кадру фактично видимих змін нема. А тому фактичний крок насправді промотував анімацію, але вона написана коряво тому так...
  const animationDuration = 15; //15 секунд фактична довжина анімації
  //видима частина анімації (так, існує і невидима, в самому кінці, відтворення якої у проміжку після 380 фрейму не призводить до будь яких змін для ока спостерігача)
  let visibilityAnimationDuration =
    (animationDuration * 1000) / badCualityLottieCoeficient;
  let animWaterCoef = visibilityAnimationDuration / stepsCount;

  // if (neededWater < 200) {
  //   //1,2,3,4,5 kilogram weight
  //   anSpeed = 4;
  // } else if (neededWater < 1000) {
  //   //6-28 kg weight
  //   anSpeed = 3;
  // } else if (neededWater < 1600) {
  //   //29-45 kg weight
  //   anSpeed = 2;
  // } else if (neededWater < 2150) {
  //   //46-61 kg weight
  //   anSpeed = 1.5;
  // } else if (neededWater < 2600) {
  //   //62- kg weight
  //   anSpeed = 1;
  // } else {
  //   anSpeed = 1;
  // } // початковий варіант від Стьопи

  if (neededWater < 200) {
    //1,2,3,4,5 kilogram weight
    anSpeed = 4;
  } else if (neededWater < 1000) {
    //6-28 kg weight
    anSpeed = 8;
  } else if (neededWater < 1600) {
    //29-45 kg weight
    anSpeed = 6;
  } else if (neededWater < 2150) {
    //46-61 kg weight
    anSpeed = 5;
  } else if (neededWater < 2600) {
    //62- kg weight
    anSpeed = 3.5;
  } else {
    anSpeed = 2;
  }  // пришвидшений варіант з прохання Діми

  const today = new Date().toISOString().split("T")[0];
  const savedData = userData?.waterBalanceData;
  const waterData = savedData ? savedData : [];
  let allChallenges = JSON.parse(localStorage.getItem('challengeNullishValue')) ?? null;
  // Знайти запис на поточну дату
  const todayData = waterData.find((entry) => entry.date === today);
  const todayDrinked = todayData ? todayData["waterAmount"] : 0;
  const [lactoseFreeDays, setLactoseFreeDays] = useState(getLastChallengeAmountValue("lactoseFreeDays", "lactoseFreeDaysStatus"));
  const [noSugarDays, setNoSugarDays] = useState(getLastChallengeAmountValue("noSugarDays", "noSugarDaysStatus"));
  const [soberDays, setSoberDays] = useState(getLastChallengeAmountValue("soberDays", "soberDaysStatus"));
  const [isZero, setIsZero] = useState(todayDrinked && 0);
  const [dailyDrinkedWater, setDrinkedWater] = useState(() => {
    // Завантаження початкового значення з localStorage

    setTimeout(() => {
      autoIncreaseWater();
    }, 200);

    // Якщо запис знайдено, повернути значення water-amount, інакше 0
    return todayDrinked;
  });
  const waterBalanceContainerRef = useRef(null);
  const timerFadeIn = useRef(null);


  useEffect(() => {
    if (waterBalanceContainerRef.current) {
      waterBalanceContainerRef.current.classList.add('water-balance-container-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      waterBalanceContainerRef.current.classList.remove('water-balance-container-fade-in');
    }, 350)

    window.scrollTo({top: 0, behavior: 'smooth'});

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  function getLastChallengeAmountValue(challengeName, challengeStatusName) {
    const challengeNullishValue = JSON.parse(localStorage.getItem('challengeNullishValue')) ?? null;
    const challengeNullishName = challengeNullishValue ? Object.keys(challengeNullishValue) : null;

    const challengeValuesArr = waterData.map(item => {
      return item[challengeName];
    });

    let lastNoNullishItem = challengeValuesArr.reverse().find(item => {
      return item !== 0;
    });

    if (challengeNullishValue) {
      if (challengeNullishName.includes(challengeStatusName)
        && challengeNullishValue[challengeStatusName] === true
        && challengeValuesArr[0] === 0) {
        lastNoNullishItem = 0;
        return lastNoNullishItem
      } else {
        return lastNoNullishItem !== undefined ? lastNoNullishItem : 0;
      }
    }
    return lastNoNullishItem !== undefined ? lastNoNullishItem : 0;
  }


  useEffect(() => {
    // Оновити або додати запис для поточної дати
    const updatedWaterData = waterData.map((entry) =>
      entry.date === today
        ? {...entry, waterAmount: dailyDrinkedWater}
        : entry
    );

    // Якщо запису на сьогодні немає, додати його
    if (!updatedWaterData.some((entry) => entry.date === today)) {
      updatedWaterData.push({
        date: today,
        lactoseFreeDays: 0,
        lactoseFreeDaysAutocompleted: false,
        lactoseFreeDaysChallengeProgressType: false,
        lactoseFreeDaysStatus: false,
        lactoseFreeDaysStatusDaily: "1970-01-01",
        noSugarDays: 0,
        noSugarDaysAutocompleted: false,
        noSugarDaysChallengeProgressType: false,
        noSugarDaysStatus: false,
        noSugarDaysStatusDaily: "1970-01-01",
        soberDays: 0,
        soberDaysAutocompleted: false,
        soberDaysChallengeProgressType: false,
        soberDaysStatus: false,
        soberDaysStatusDaily: "1970-01-01",
        waterAmount: dailyDrinkedWater,
      });
    }

    if (updatedWaterData) {
      if (userData) {
        userData["waterBalanceData"] = [...updatedWaterData];
      }
    }

    localStorage.setItem(userID, JSON.stringify(userData));
  }, [dailyDrinkedWater, today]);


  useEffect(() => {
    if (lactoseFreeDays > 0) {
      const isChosenChallengeStatus = JSON.parse(localStorage.getItem('isBegun')) ?? false;
      localStorage.setItem('isBegun', JSON.stringify({
          ...isChosenChallengeStatus,
          'lactoseFreeDaysAutocompleted': true,
        }
      ));
    } else {
      const isChosenChallengeStatus = JSON.parse(localStorage.getItem('isBegun')) ?? false;
      localStorage.setItem('isBegun', JSON.stringify({
          ...isChosenChallengeStatus,
          'lactoseFreeDaysAutocompleted': false,
        }
      ));
    }

    if (noSugarDays > 0) {
      const isChosenChallengeStatus = JSON.parse(localStorage.getItem('isBegun')) ?? false;
      localStorage.setItem('isBegun', JSON.stringify({
          ...isChosenChallengeStatus,
          'noSugarDaysAutocompleted': true,
        }
      ));
    } else {
      const isChosenChallengeStatus = JSON.parse(localStorage.getItem('isBegun')) ?? false;
      localStorage.setItem('isBegun', JSON.stringify({
          ...isChosenChallengeStatus,
          'noSugarDaysAutocompleted': false,
        }
      ));
    }

    if (soberDays > 0) {
      const isChosenChallengeStatus = JSON.parse(localStorage.getItem('isBegun')) ?? false;
      localStorage.setItem('isBegun', JSON.stringify({
          ...isChosenChallengeStatus,
          'soberDaysAutocompleted': true,
        }
      ));
    } else {
      const isChosenChallengeStatus = JSON.parse(localStorage.getItem('isBegun')) ?? false;
      localStorage.setItem('isBegun', JSON.stringify({
          ...isChosenChallengeStatus,
          'soberDaysAutocompleted': false,
        }
      ));
    }
  }, [lactoseFreeDays, noSugarDays, soberDays]);


  const handleChallenges = (selectedItem) => {
    // Зупинити анімацію перед навігацією
    if (animationWater.current) {
      animationWater.current.setSpeed(0);
      anSpeed = 0;
    }

    const isChosenChallengeStatus = JSON.parse(localStorage.getItem('isBegun')) ?? false;
    console.log(isChosenChallengeStatus)
    console.log(selectedItem)
    console.log(isChosenChallengeStatus[selectedItem.concat('Autocompleted')])

    if (Object.keys(isChosenChallengeStatus).includes(selectedItem.concat('Autocompleted')) &&
      isChosenChallengeStatus[selectedItem.concat('Autocompleted')]) {
      navigate(Routes.waterChallengeOpen, {
        state: {
          choicedChallenge: selectedItem,
          chosenChallengeDaysAmount: selectedItem === "lactoseFreeDays" ? lactoseFreeDays :
            selectedItem === "noSugarDays" ? noSugarDays :
              selectedItem === "soberDays" ? soberDays : 0,
          allChallenges: allChallenges,
        },
      });
    } else {
      navigate(Routes.waterChallenge, {
        state: {
          choicedChallenge: selectedItem,
          chosenChallengeDaysAmount: selectedItem === "lactoseFreeDays" ? lactoseFreeDays :
            selectedItem === "noSugarDays" ? noSugarDays :
              selectedItem === "soberDays" ? soberDays : 0,
          allChallenges: allChallenges,
        },
      });
    }
  };


  const defaultOptions = {
    loop: false,
    autoplay: false,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };


  const checkIsZeroWater = (newDrinkedWater) => {
    if (newDrinkedWater <= 0) {
      setIsZero(true);
    } else {
      setIsZero(false);
    }
  };


  const autoIncreaseWater = () => {
    let drinkedSteps = todayDrinked / step; //600 / 200;
    let initAnimationLoad =
      (visibilityAnimationDuration / stepsCount) * drinkedSteps; //12666 (або 12,6 сек) * 3
    if (initAnimationLoad === 0) {
      return false;
    }

    if (isAnimating) return; // Перевіряємо, чи не відтворюється анімація, щоб не дозволити подвійні кліки
    setIsAnimating(true); // Встановлюємо статус анімації
    const initAnimSpeed = 6; // початкове значення від Стьопи - const initAnimSpeed = 4;

    let animationDuration =
      (visibilityAnimationDuration / stepsCount / initAnimSpeed) * drinkedSteps;

    if (animationWater.current) {
      animationWater.current.play();
    }
    setAnimationSpeed(6); // початкове значення від Стьопи - setAnimationSpeed(4);

    setTimeout(() => {
      setAnimationSpeed(0);
      setIsAnimating(false); // Після завершення анімації знову дозволяємо кліки
    }, animationDuration);
  };


  const increaseWater = () => {
    if (isAnimating) return; // Перевіряємо, чи не відтворюється анімація, щоб не дозволити подвійні кліки
    checkIsZeroWater(dailyDrinkedWater + step); // Перевірка після оновлення води

    if (neededWater > dailyDrinkedWater - 200) {
      setIsAnimating(true); // Встановлюємо статус анімації

      animationWater.current.play();
      setAnimationSpeed(anSpeed);

      setDrinkedWater(dailyDrinkedWater + step);

      setTimeout(() => {
        setAnimationSpeed(0);
        setIsAnimating(false); // Після завершення анімації знову дозволяємо кліки
      }, animWaterCoef / anSpeed);
    } else {
      setDrinkedWater(dailyDrinkedWater + step);
    }
  };


  const decreaseWater = (step) => {
    if (isAnimating || isZero) return; // Забороняємо клік, поки анімація триває або якщо води вже 0
    checkIsZeroWater(dailyDrinkedWater - step); // Перевірка після оновлення води

    if (neededWater > dailyDrinkedWater - step) {
      setIsAnimating(true);

      // Встановлення швидкості анімації на основі кроку
      const animationDuration = (animWaterCoef / anSpeed) * (step / 200); // Адаптуємо тривалість анімації на основі кроку

      setAnimationSpeed(0 - anSpeed);
      setDrinkedWater(dailyDrinkedWater - step);

      setTimeout(() => {
        setAnimationSpeed(0);
        setIsAnimating(false);
      }, animationDuration);
    } else {
      setDrinkedWater(dailyDrinkedWater - step);
    }
  };


  useEffect(() => {
    const sendWaterBalanceData = async () => {
      const allChallenges = JSON.parse(localStorage.getItem('challengeNullishValue'));
      const allChallengesStatusDaily = JSON.parse(localStorage.getItem('challengeStatus'));
      const allChallengesStatusBegun = JSON.parse(localStorage.getItem('isBegun'));
      const challengeAutoUpdating = JSON.parse(localStorage.getItem('challengeAutoUpdating'));

      const todayWaterBalanceData = waterData
        ? waterData.find((item) => {
          return item.date === new Date().toISOString().split("T")[0];
        })
        : null;

      try {
        if (todayWaterBalanceData) {
          await ServerRequest.sendWaterBalanceData(
            challengeAutoUpdating,
            allChallengesStatusBegun,
            allChallengesStatusDaily,
            allChallenges,
            todayWaterBalanceData,
            userID
          );
        }
      } catch (error) {
        console.error("Error sending user response by workout:", error);
      }
    };

    (async () => {
      await sendWaterBalanceData();
    })();
  }, [todayDrinked, lactoseFreeDays, noSugarDays, soberDays]);


  return (userID || userData ?
      (<div ref={waterBalanceContainerRef}
            className="main-container water-balance">
        <div className="outer-content">
          <img
            className="main-logo"
            src={require("./img/avo-bottle.png")}
            alt="logo"
          />
          <p className="main-text">{texts.water["main-text"]}</p>
        </div>

        <div className="inner-content">
          <div className="workout-navigation">
            <img
              className="workout-navigation__arrow"
              onClick={() => navigate(Routes.mainPage)}
              src={require("../../assets/img/back_arrow.svg").default}
              width="24"
              height="24"
              alt="image arrow left"
            ></img>
          </div>

          <div className="water-balance">
            <div className="water-balance__animation">
              <Lottie
                options={defaultOptions}
                isClickToPauseDisabled={true}
                speed={animationSpeed}
                // width={200}
                // height={200}
                ariaLabel="animation"
                ref={animationWater}
              />
              <button
                className={`water-balance__button water-balance__button--decrease ${
                  isAnimating ? "disabled" : ""
                } ${isZero ? "disabled" : ""}`}
                onClick={() => decreaseWater(step)}
              >
                <img
                  className="water-balance_image"
                  src={require("./img/minus_water.svg").default}
                  alt="logo"
                />
              </button>

              <button
                className={`water-balance__button water-balance__button--increase ${
                  isAnimating ? "disabled" : ""
                }`}
                onClick={() => increaseWater(step)}
              >
                <img
                  className="water-balance_image"
                  src={require("./img/plus_water.svg").default}
                  alt="logo"
                />
              </button>

              <div className="water-balance_drinked">
                {dailyDrinkedWater} {texts.water.ml}
              </div>
            </div>

            <span className="user-daily_portion">
            {texts.water["user-goal"] + neededWater + " " + texts.water.ml}
          </span>

            <div className="water-balance__challenges">
              <h3 className="water-balance__challenges-title">
                {texts.water.subtitle}
              </h3>
              <div
                className="water-balance__challenge-block"
                onClick={() => {
                  handleChallenges("lactoseFreeDays");
                }}
              >
                <div className="water-balance__challenge-top">
                  <img
                    className="water-balance__challenge-icon"
                    src={require("./img/icon_lactose_free.svg").default}
                    alt="lactose free"
                  />
                  <h3 className="water-balance__challenge-title">
                    {texts.water["lactoseFreeDays"].small_box_title}
                  </h3>
                </div>
                <div className="water-balance__challenge-text">
                  {texts.water["lactoseFreeDays"].small_box_text}
                </div>
                <div className="water-balance__open_challenge">
                  <div className="water-balance__arrows">
                    <img
                      className="water-balance__challenge-icon-arrow"
                      src={require("./img/arrows.svg").default}
                      alt="arrows"
                    />
                  </div>
                  {lactoseFreeDays < 1 ? (
                    <div className="water-balance__transform_block">
                      {texts.water["challenge-duration"]}
                    </div>
                  ) : (
                    <div className="water-balance__challenge-done">
                      <strong>{lactoseFreeDays}/10</strong> {texts.water["days"]}
                    </div>
                  )}
                </div>
              </div>

              <div
                className="water-balance__challenge-block"
                onClick={() => {
                  handleChallenges("noSugarDays");
                }}
              >
                <div className="water-balance__challenge-top">
                  <img
                    className="water-balance__challenge-icon"
                    src={require("./img/icon_no_sugar.svg").default}
                    alt="no sugar"
                  />
                  <h3 className="water-balance__challenge-title">
                    {texts.water["noSugarDays"].small_box_title}
                  </h3>
                </div>
                <div className="water-balance__challenge-text">
                  {texts.water["noSugarDays"].small_box_text}
                </div>
                <div className="water-balance__open_challenge">
                  <div className="water-balance__arrows">
                    <img
                      className="water-balance__challenge-icon-arrow"
                      src={require("./img/arrows.svg").default}
                      alt="arrows"
                    />
                  </div>
                  {noSugarDays < 1 ? (
                    <div className="water-balance__transform_block">
                      {texts.water["challenge-duration"]}
                    </div>
                  ) : (
                    <div className="water-balance__challenge-done">
                      <strong>{noSugarDays}/10</strong> {texts.water["days"]}
                    </div>
                  )}
                </div>
              </div>

              <div
                className="water-balance__challenge-block"
                onClick={() => {
                  handleChallenges("soberDays");
                }}
              >
                <div className="water-balance__challenge-top">
                  <img
                    className="water-balance__challenge-icon"
                    src={require("./img/icon_sober_days.svg").default}
                    alt="sober days"
                  />
                  <h3 className="water-balance__challenge-title">
                    {texts.water["soberDays"].small_box_title}
                  </h3>
                </div>
                <div className="water-balance__challenge-text">
                  {texts.water["soberDays"].small_box_text}
                </div>
                <div className="water-balance__open_challenge">
                  <div className="water-balance__arrows">
                    <img
                      className="water-balance__challenge-icon-arrow"
                      src={require("./img/arrows.svg").default}
                      alt="arrows"
                    />
                  </div>
                  {soberDays < 1 ? (
                    <div className="water-balance__transform_block">
                      {texts.water["challenge-duration"]}
                    </div>
                  ) : (
                    <div className="water-balance__challenge-done">
                      <strong>{soberDays}/10</strong> {texts.water["days"]}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>) : null
  );
};

export default WaterBalance;